import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { useSelector } from 'react-redux';
import Moment from 'moment';
import {
  Col,
  Row,
  Modal,
  Form,
  Spin,
  Button,
  Input,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import { postObtenerReporte } from 'api/reporteador';
import { getUnidadDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import Previewer from 'components/Previewer';
import { capitalize } from 'utils/normalizers';
import { getRemolque } from 'api/recaudacion/remolque';

export const tiposDeTramitesReporteador = [
  { descripcion: 'Alta' },
  { descripcion: 'Compraventa' },
  { descripcion: 'Cambio de Propietario' },
  { descripcion: 'Refrendo' },
  { descripcion: 'Cambio de Motor' },
];

export const imprimirTarjetaDeCirculacionRemolque = async (
  setLoading = () => { },
  tramite,
  selectedRowKey,
  callback = () => { },
) => {
  setLoading(true);
  const match = await getRemolque(selectedRowKey);
  const _unidadDeRecaudacion = await getUnidadDeRecaudacion(match?.unidad_de_recaudacion || 1);
  const fechaDeExpedicion = new Moment().format(DATE_FRONTEND_FORMAT.replace('\\/', '-'));
  const values = {
    ID: match.es_propietario_ciudadano ? 65 : 67,
    Parametros: [
      {
        Nombre: 'clave',
        TipoParametro: 'Texto',
        Valor: match.clave,
      },
      {
        Nombre: 'fecha_expedicion',
        TipoParametro: 'Texto',
        Valor: fechaDeExpedicion,
      },
      {
        Nombre: 'clave_recaudadora',
        TipoParametro: 'Texto',
        Valor: _unidadDeRecaudacion.clave,
      },
      {
        Nombre: 'marca',
        TipoParametro: 'Texto',
        Valor: tramite.marca,
      },
      {
        Nombre: 'tramite',
        TipoParametro: 'Texto',
        Valor: tramite.tramite,
      },
      {
        Nombre: 'anio',
        TipoParametro: 'Texto',
        Valor: tramite.anio,
      },
    ],
  };
  const file = await postObtenerReporte(values);
  callback(file);
  setLoading(false);
  return file;
};

const imprimirTarjetaDeCirculacion = async (
  setLoading = () => { },
  tramite,
  selectedRowKey,
  callback = () => { },
  getterById,
  IDS,
) => {
  setLoading(true);
  const match = await getterById(selectedRowKey);
  const unidadDeRecaudacion = await getUnidadDeRecaudacion(match.unidad_de_recaudacion || 1);
  const fechaDeExpedicion = new Moment().format(DATE_FRONTEND_FORMAT.replace('\\/', '-'));
  const values = {
    ID: match.es_propietario_ciudadano ? IDS[0] : IDS[1],
    Parametros: [
      {
        Nombre: 'clave',
        TipoParametro: 'Texto',
        Valor: match.clave,
      },
      {
        Nombre: 'fecha_expedicion',
        TipoParametro: 'Texto',
        Valor: fechaDeExpedicion,
      },
      {
        Nombre: 'clave_recaudadora',
        TipoParametro: 'Texto',
        Valor: unidadDeRecaudacion.clave,
      },
      {
        Nombre: 'marca',
        TipoParametro: 'Texto',
        Valor: tramite.marca,
      },
      {
        Nombre: 'tramite',
        TipoParametro: 'Texto',
        Valor: tramite.tramite,
      },
    ],
  };
  const file = await postObtenerReporte(values);
  callback(file);
  setLoading(false);
  return file;
};

const ModalTarjetaDeCirculacion = ({
  visible,
  setVisible,
  selectedRowKey,
  getterById,
  IDS,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [base64, setBase64] = useState();

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const onFinish = async () => {
    try {
      const values = form.getFieldsValue();
      setLoading(true);
      await imprimirTarjetaDeCirculacion(
        setLoading,
        values,
        selectedRowKey,
        (file) => {
          setBase64(file);
          setVisiblePreview(true);
        },
        getterById,
        IDS,
      );
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const saveControl = {
    text: 'Guardar',
    icon: <SaveOutlined />,
    onClick: () => onFinish(),
  };

  const backControl = {
    text: 'Regresar',
    icon: <ArrowLeftOutlined />,
    onClick: () => onCancel(),
  };

  const getControls = () => [backControl, saveControl];

  const rules = { required: [{ required: true }] };

  return (
    <Modal
      footer={null}
      closable={false}
      visible={visible}
      loading={loading}
      title={(
        <FormSubmitControls
          loading={loading}
          label="Datos Necesarios para la Tarjeta"
          controls={getControls()}
        />
      )}
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Row>
          <Col span={24}>
            <Form
              form={form}
              layout="vertical"
              name="tarjeta"
              onFinish={() => onFinish()}
            >
              <Col span={24}>
                <Form.Item
                  name="marca"
                  label="Marca y Submarca"
                  hasFeedback
                  rules={rules.required}
                  normalize={capitalize}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="tramite"
                  label="Tipo de Tramite"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    dataSource={tiposDeTramitesReporteador}
                    valueProp="descripcion"
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Spin>
      <Previewer
        visible={visiblePreview}
        setVisible={setVisiblePreview}
        base64={base64}
      />
    </Modal>
  );
};

ModalTarjetaDeCirculacion.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  selectedRowKey: PropTypes.number,
  getterById: PropTypes.func.isRequired,
  IDS: PropTypes.arrayOf(PropTypes.number).isRequired,
};

ModalTarjetaDeCirculacion.defaultProps = {
  selectedRowKey: null,
};
export default ModalTarjetaDeCirculacion;
